import React from "react";
import SchoolCalendar from "./SchoolCalendar";
import SuperadminCalendar from "./SuperadminCalendar";

const CalendarPage: React.FC = () => {
  const role = (localStorage.getItem("role") || "").toLowerCase();
  return role === "superadmin" ? <SuperadminCalendar /> : <SchoolCalendar />;
};

export default CalendarPage;
